var invalidColor = "Invalid color";
var label = "Color value";
var _en = {
	invalidColor: invalidColor,
	label: label
};

export { _en as default, invalidColor, label };
